import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-locked-qs',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './locked-qs.component.html',
  styleUrl: './locked-qs.component.scss'
})
export class LockedQsComponent {

}
